import { useEffect, useState } from "react";

export default function FavoriteCards() {
  const [tags, setTags] = useState([]);
  const [dados, setDados] = useState([]);
  const [socket, setSocket] = useState(null);

  useEffect(() => {
    fetch("/upload")
      .then((res) => res.json())
      .then((data) => setTags(data.filter((tag) => tag.favorito)));

    const newSocket = new WebSocket("ws://localhost:5000/ws");
    setSocket(newSocket);

    return () => newSocket.close();
  }, []);

  useEffect(() => {
    if (!socket) return;

    socket.onmessage = (event) => {
      const data = JSON.parse(event.data);
      setDados(data);
    };

    return () => {
      socket.onmessage = null;
    };
  }, [socket]);

  return (
    <div className="p-4">
      <h2 className="text-2xl font-bold mb-4">⭐ Sinais Favoritos</h2>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        {tags.map((tag, i) => {
          const valor = dados.find((d) => d.desc === tag.desc)?.value;
          const foraLimite =
            typeof valor === "number" &&
            (valor < tag.limiteMin || valor > tag.limiteMax);
          const cor = valor === undefined
            ? "bg-gray-600"
            : foraLimite
            ? "bg-red-600 text-white"
            : "bg-green-700 text-white";

          return (
            <div key={i} className={`p-4 rounded shadow ${cor}`}>
              <h3 className="text-lg font-semibold mb-1">
                {tag.desc} ({tag.plc})
              </h3>
              <p>
                <strong>Endereço:</strong>{" "}
                {tag.type === "bool"
                  ? `${tag.area}${tag.db}.DBX${tag.byte}.${tag.bit}`
                  : `${tag.area}${tag.db}.DB${tag.type[0].toUpperCase()}${tag.byte}`}
              </p>
              <p><strong>Valor:</strong> {valor !== undefined ? String(valor) : "-"}</p>
              <p><strong>Unidade:</strong> {tag.unidade ?? "-"}</p>
              <p>
                <strong>Limites:</strong>{" "}
                {(tag.limiteMin ?? "-") + " a " + (tag.limiteMax ?? "-")}
              </p>
            </div>
          );
        })}
      </div>
    </div>
  );
}
